import html2pdf from "html2pdf.js";
import {
  QueryClient,
  useQuery,
  useQueryClient,
} from "react-query";
import * as XLSX from "xlsx";
import {
  decryptedText,
  encryptedText,
  getAllLocations,
  getAllOrganizations,
  getAllQuestionCategory,
  getAllResponseTypes,
  getAllUserClassifications,
  getAllUserDepartments,
  getAllUserDesignations,
  getSurveyAssignmentsWithoutPublic,
} from "./ApiUrl";
import { axiosPost } from "./AxiosHelper";
import { RoleTypeCode, showToast, ToastTypeCode } from "./Constant";

export let PageRecordLimit: number =
  Number(localStorage.getItem("PageRecordLimit")) || 10;

export const setPageRecordLimit = (newLimit: number) => {
  PageRecordLimit = newLimit;
  localStorage.setItem("PageRecordLimit", newLimit.toString());
};

export const DateFormatCommon = "dd/MM/yyyy";

const encrypt = async (text: any) => {
  const response: any = await axiosPost(encryptedText, {
    plainText: text,
  });

  return response?.data.ExtraData;
};

export const formatDateToDDMMStringYY = (dateString?: string | null): string => {
  if (!dateString) return "";

  return new Date(dateString)
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
};

export const particularOrganization = -1;

const decrypt = async (text: any) => {
  const response: any = await axiosPost(decryptedText, {
    encryptText: text,
  });

  return response?.data.ExtraData;
};

export const getCurrentDate = (): string => {
  const now = new Date();
  return now.toISOString();
};

export const getCurrentDateReturningObject = (): Date => {
  return new Date();
};

export const convertToUTC = (date: any): string => {
  const parsedDate = typeof date === "string" ? new Date(date) : date;
  return parsedDate.toISOString();
};

export const fetchOrganization = async (): Promise<Option[]> => {
  try {
    const response: any = await axiosPost(getAllOrganizations, {
      SearchText: "",
      IsActive: true,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "ASC",
      SortBy: "OrganizationId",
    });

    const data = response.data.ExtraData || [];
    const options = data?.map((item: any) => ({
      label: item.OrganizationName,
      value: item.OrganizationId,
    }));
    return options;
  } catch (error) {
    return [];
  }
};

export const copyToClipboard = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      showToast("Text copied to clipboard", ToastTypeCode?.SUCCESS);
    })
    .catch((err) => {
      showToast("Error in copying text: ", ToastTypeCode?.ERROR);
    });
};

export const fetchSurveyAssignments = async (
  appContextdata: any,
  Formtype: any
): Promise<any[]> => {
  try {
    const response: any = await axiosPost("/Dashboard/GetSurveyAssignments", {
      OrganizationId: appContextdata?.OrganizationId,
      FormType: Formtype,
      SortDir: 'DESC'
    });

    const data = response?.data?.ExtraData || [];

    return data;
  } catch (error) {
    return [];
  }
};

export const fetchSurveyAssignmentswithoutPublic = async (
  appContextdata: any,
  Formtype: number
): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getSurveyAssignmentsWithoutPublic, {
      OrganizationId: appContextdata?.OrganizationId,
      FormType: Formtype,
      SortDir: 'DESC'
    });

    const data = response?.data?.ExtraData || [];

    return data;
  } catch (error) {
    return [];
  }
};

export { decrypt, encrypt };

export interface Option {
  label: string;
  value: number;
  valueString?: string;
}
export interface Organization {
  OrganizationId: number;
  OrganizationName: string;
}
export const checkIfSuperAdmin = (appContextdata: any) => {
  const role = appContextdata?.Role;
  return role === RoleTypeCode?.SuperAdmin;
};
export const IsAdmin = (appContextdata: any) => {
  const role = appContextdata?.Role;
  return role === RoleTypeCode?.Administrator;
};

export const backgroundColors = [
  "#00C3E1", "#5C6BC0", "#9575CD", "#FF6E40", "#FFD54F",
  "#81C784", "#FF8A65", "#a4c639", "#4DB6AC", "#90CAF9",
  "#BA68C8", "#4FC3F7", "#AED581", "#FFCA28", "#B0BEC5",
  "#66BB6A", "#F06292", "#7986CB", "#26C6DA", "#FFB74D",
  "#C8E6C9", "#81D4FA", "#E1BEE7", "#FFF176", "#A5D6A7",
  "#64B5F6", "#CE93D8", "#FFF59D", "#80CBC4", "#D7CCC8",
  "#B39DDB", "#4DB3FF", "#FFAB91", "#FDD835", "#DCEDC8",
  "#B3E5FC", "#FFD180", "#E6EE9C", "#B2EBF2", "#FF7043",
  "#E0E0E0", "#BDBDBD", "#90A4AE", "#9CCC65", "#4DD0E1",
  "#F48FB1", "#EF9A9A", "#7986CB", "#C5CAE9", "#A1887F"
];

export const borderColors = [
  "#00C3E1", "#5C6BC0", "#9575CD", "#FF6E40", "#FFD54F",
  "#81C784", "#FF8A65", "#a4c639", "#4DB6AC", "#90CAF9",
  "#BA68C8", "#4FC3F7", "#AED581", "#FFCA28", "#B0BEC5",
  "#66BB6A", "#F06292", "#7986CB", "#26C6DA", "#FFB74D",
  "#C8E6C9", "#81D4FA", "#E1BEE7", "#FFF176", "#A5D6A7",
  "#64B5F6", "#CE93D8", "#FFF59D", "#80CBC4", "#D7CCC8",
  "#B39DDB", "#4DB3FF", "#FFAB91", "#FDD835", "#DCEDC8",
  "#B3E5FC", "#FFD180", "#E6EE9C", "#B2EBF2", "#FF7043",
  "#E0E0E0", "#BDBDBD", "#90A4AE", "#9CCC65", "#4DD0E1",
  "#F48FB1", "#EF9A9A", "#7986CB", "#C5CAE9", "#A1887F",
];

// utils/common.ts
export const backgroundColorsPieChart = [
  "#00C3E1", "#5C6BC0", "#9575CD", "#FF6E40", "#FFD54F",
  "#81C784", "#FF8A65", "#a4c639", "#4DB6AC", "#90CAF9",
  "#BA68C8", "#4FC3F7", "#AED581", "#FFCA28", "#B0BEC5",
  "#66BB6A", "#F06292", "#7986CB", "#26C6DA", "#FFB74D",
  "#C8E6C9", "#81D4FA", "#E1BEE7", "#FFF176", "#A5D6A7",
  "#64B5F6", "#CE93D8", "#FFF59D", "#80CBC4", "#D7CCC8",
  "#B39DDB", "#4DB3FF", "#FFAB91", "#FDD835", "#DCEDC8",
  "#B3E5FC", "#FFD180", "#E6EE9C", "#B2EBF2", "#FF7043",
  "#E0E0E0", "#BDBDBD", "#90A4AE", "#9CCC65", "#4DD0E1",
  "#F48FB1", "#EF9A9A", "#7986CB", "#C5CAE9", "#A1887F",
];

export const borderColorsPieChart = [
  "#00C3E1", "#5C6BC0", "#9575CD", "#FF6E40", "#FFD54F",
  "#81C784", "#FF8A65", "#a4c639", "#4DB6AC", "#90CAF9",
  "#BA68C8", "#4FC3F7", "#AED581", "#FFCA28", "#B0BEC5",
  "#66BB6A", "#F06292", "#7986CB", "#26C6DA", "#FFB74D",
  "#C8E6C9", "#81D4FA", "#E1BEE7", "#FFF176", "#A5D6A7",
  "#64B5F6", "#CE93D8", "#FFF59D", "#80CBC4", "#D7CCC8",
  "#B39DDB", "#4DB3FF", "#FFAB91", "#FDD835", "#DCEDC8",
  "#B3E5FC", "#FFD180", "#E6EE9C", "#B2EBF2", "#FF7043",
  "#E0E0E0", "#BDBDBD", "#90A4AE", "#9CCC65", "#4DD0E1",
  "#F48FB1", "#EF9A9A", "#7986CB", "#C5CAE9", "#A1887F",
];

export const formatDateCommon = (date: any, displayDash = false) => {
  const originalDate = new Date(date);
  const day = originalDate.getDate().toString().padStart(2, "0");
  const month = (originalDate.getMonth() + 1).toString().padStart(2, "0");
  const year = originalDate.getFullYear().toString();
  return `${day}/${month}/${year}`;
};

export const createExcelFile = (data: any, fileName: string) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, fileName + ".xlsx");
};

export const hhmmToSeconds = (timeString: string) => {
  const [hours, minutes] = (timeString ?? "").split(":")?.map(Number) || ["", ""];
  return hours * 3600 + minutes * 60;
};

export const convertUTCToLocalTimeDate = (utcString: string) => {
  const utcDate = new Date(utcString);
  return new Date(
    utcDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
};

export const useGetFetchQuery = (name: any) => {
  const queryClient = useQueryClient();

  return queryClient.getQueryData(name);
};

export const fetchQuestionCategories = async (
  organizationId: number
): Promise<Option[]> => {

  const response: any = await axiosPost(getAllQuestionCategory, {
    SearchText: "",
    IsActive: true,
    CurrentPageNo: 1,
    PageSize: 0,
    SortDir: "DESC",
    SortBy: "QuestionCategoryId",
    OrganizationId: organizationId,
  });
  const data = response.data.ExtraData || [];
  return data?.map((item: any) => ({
    label: item.QuestionCategoryName,
    value: item.QuestionCategoryId,
  }));
};


export const useFetchQuestionCategories = (organizationId: number) => {
  return useQuery(
    ["questioncategory", organizationId],
    () => fetchQuestionCategories(organizationId),
    {
      enabled: !!organizationId,
      onError: () => {
        showToast("Error fetching questioncategory", ToastTypeCode?.ERROR);
      },
    }
  );
};

export const fetchOrganizations = async (): Promise<Option[]> => {
  const response: any = await axiosPost(getAllOrganizations, {
    SearchText: "",
    IsActive: true,
    CurrentPageNo: 1,
    PageSize: 0,
    SortDir: "DESC",
    SortBy: "OrganizationId",
  });

  if (response?.data?.Status === 200) {
    return (
      response?.data?.ExtraData?.map((item: any) => ({
        label: item?.OrganizationName,
        value: item?.OrganizationId,
      })) || []
    );
  } else {
    throw new Error("Error fetching organizations");
  }
};

export const convertToIST = (utcDateString: string): string => {
  if (!utcDateString) return "Invalid Date";
  const utcDate = new Date(utcDateString);
  return utcDate.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
};

export const useOrganizations = () => {
  return useQuery({
    queryKey: ["organizations"],
    queryFn: fetchOrganizations,
    onError: () => {
      showToast("Error fetching organizations", ToastTypeCode?.ERROR);
    },
  });
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
    },
  },
});

export const getCachedData = async (key: any) => {
  let data = queryClient.getQueryData(key);

  if (!data && key === "organizations") {
    // Fetch the data if it's not cached
    data = await queryClient.fetchQuery({
      queryKey: ["organizations"],
      queryFn: fetchOrganizations,
    });
  }
  return data || [];
};

const fetchDepartments = async (organizationId: number): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getAllUserDepartments, {
      SearchText: "",
      IsActive: 1,
      OrganizationId: organizationId || -1,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "DESC",
      SortBy: "UserId", // Adjust this if sorting should be done differently
    });

    if (response?.data?.Status === 200) {
      return (
        response?.data?.ExtraData?.map((item: any) => ({
          label: item?.DepartmentName, // Ensure this maps to the correct property
          value: item?.DepartmentId, // Ensure this maps to the correct property
        })) || []
      );
    } else {
      showToast("Error fetching departments", ToastTypeCode?.ERROR);
      return [];
    }
  } catch (error) {
    showToast("Error fetching departments", ToastTypeCode?.ERROR);
    return [];
  }
};

// Usage with React Query
export const useFetchDepartments = (organizationId: number) => {
  return useQuery(
    ["department", organizationId],
    () => fetchDepartments(organizationId),
    {
      enabled: !!organizationId,
      onError: () => {
        showToast("Error fetching departments", ToastTypeCode?.ERROR);
      },
    }
  );
};

const fetchDesignation = async (organizationId: number): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getAllUserDesignations, {
      SearchText: "",
      IsActive: 1,
      OrganizationId: organizationId ? organizationId : -1,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "DESC",
      SortBy: "UserId",
    });
    if (response?.data?.Status === 200) {
      return (
        response?.data?.ExtraData?.map((item: any) => ({
          label: item?.DesignationName,
          value: item?.DesignationId,
        })) || []
      );
    } else {
      showToast("Error fetching Designation", ToastTypeCode?.ERROR);
      return [];
    }
  } catch (error) {
    showToast("Error fetching Designation", ToastTypeCode?.ERROR);
    return [];
  }
};

export const useFetchDesignation = (organizationId: number) => {
  return useQuery(
    ["designation", organizationId],
    () => fetchDesignation(organizationId),
    {
      enabled: !!organizationId,
      onError: () => {
        showToast("Error fetching designations", ToastTypeCode?.ERROR);
      },
    }
  );
};

const fetchClassification = async (organizationId: number): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getAllUserClassifications, {
      SearchText: "",
      IsActive: 1,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "DESC",
      SortBy: "UserId",
      OrganizationId: organizationId ? organizationId : -1,
    });
    if (response?.data?.Status === 200) {
      return (
        response?.data?.ExtraData?.map((item: any) => ({
          label: item?.ClassificationName,
          value: item?.ClassificationID,
        })) || []
      );
    } else {
      showToast("Error fetching Classification", ToastTypeCode?.ERROR);
      return [];
    }
  } catch (error) {
    showToast("Error fetching Classification", ToastTypeCode?.ERROR);
    return [];
  }
};

export const useFetchClassification = (organizationId: number) => {
  return useQuery(
    ["classification", organizationId],
    () => fetchClassification(organizationId),
    {
      enabled: !!organizationId,
      onError: () => {
        showToast("Error fetching classifications", ToastTypeCode?.ERROR);
      },
    }
  );
};

const fetchLocation = async (organizationId: number): Promise<any[]> => {
  try {
    const response: any = await axiosPost(getAllLocations, {
      SearchText: "",
      IsActive: 1,
      OrganizationId: organizationId ? organizationId : -1,
      CurrentPageNo: 1,
      PageSize: 0,
      SortDir: "DESC",
      SortBy: "UserId",
    });
    if (response?.data?.Status === 200) {
      return (
        response?.data?.ExtraData?.map((item: any) => ({
          label: item?.LocationName,
          value: item?.LocationId,
        })) || []
      );
    } else {
      showToast("Error fetching Location", ToastTypeCode?.ERROR);
      return [];
    }
  } catch (error) {
    showToast("Error fetching Location", ToastTypeCode?.ERROR);
    return [];
  }
};


export const useFetchLocation = (organizationId: number) => {
  return useQuery(
    ["location", organizationId],
    () => fetchLocation(organizationId),
    {
      enabled: !!organizationId,
      onError: () => {
        showToast("Error fetching classifications", ToastTypeCode?.ERROR);
      },
    }
  );
};


const fetchResponseTypes = async (): Promise<Option[]> => {
  const response: any = await axiosPost(getAllResponseTypes, {
    SearchText: "",
    IsActive: true,
    CurrentPageNo: 1,
    PageSize: 0,
    SortDir: "ASC",
    SortBy: "ResponseTypeId",
  });
  const data = response?.data?.ExtraData || [];
  return data?.map((item: any) => ({
    label: item?.DisplayResponseType,
    value: item.ResponseTypeId,
  }));
};



export const useFetchResponseTypes = () => {
  return useQuery(
    "responseTypes",
    fetchResponseTypes,
    {
      onError: () => {
        showToast("Error fetching response types", ToastTypeCode?.ERROR);
      },
    }
  );
};


export const viewOptionsList = [
  { label: "Percentage", value: 1 },
  { label: "Count", value: 2 },
];

export type QuestionActiveMap = Record<number, boolean>;
export type SectionQuestionMap = Record<number, QuestionActiveMap>;

export type TemplateOption = {
  TemplateQuestionOptionId: number;
  ResponseTypeId: number;
  ResponseTypeName: string;
  OptionTitle: string;
  IsActive: boolean;
  IsCorrect: boolean | null;
};

export type TemplateQuestion = {
  TemplateQuestionId: number;
  TemplateSectionId: number;
  QuestionTitle: string;
  Instruction: string;
  IsActive: boolean;
  IsRequired: boolean;
  Options: TemplateOption[];
};

export type TemplateCategory = {
  TemplateCategoryId: number;
  CategoryName: string;
  TemplateSectionId: number;
  TemplateSectionName: string;
  CategoryDescription: string;
  TemplateSubcategoryId: number;
  SubcategoryName: string;
  SubcategoryDescription: string;
  Questions: TemplateQuestion[];
  CreateUserId: number;
};

export type TemplateSectionList = {
  TemplateSectionId: number;
  TemplateSectionName: string;
  TemplateSubcategoryId: number;
};

type UpdateCurrentPageFn = React.Dispatch<React.SetStateAction<number>>;

export function handlePaginationAfterDelete(
  status: number,
  pageSize: number,
  currentPage: number,
  setCurrentPage: UpdateCurrentPageFn,
  totalRecords: number
): number {
  let currentPageReturn: number = currentPage;
  if (status === 200) {
    const remainingRecords = (totalRecords - 1) % pageSize;

    if (remainingRecords === 0) {
      if (currentPage > 1) {
        currentPageReturn = currentPage - 1;
        setCurrentPage(currentPage - 1);
      }
    }
  }
  return currentPageReturn;
}

export const attributeDisplayNameMap: Record<string, string> = {
  response_count: "Response Limit",
  user_count: "Max Active Users",
  survey_count: "Total Surveys Allowed",
  Question_per_survey: "Questions per Survey",
  Allow_sentiment: "Sentiment Analysis Enabled",
  report: "Report",
  Allow_public_survey: "Allow Public Surveys",
  Allow_demography: "Demographic Insights",
};

export interface CustomIcon {
  label: string;
  fillColor: string;
}

export const generatePDF = (elementId: string, filename: string) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  const options: any = {
    margin: 10,
    filename,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  };

  html2pdf().set(options).from(element).save();
};

export const downloadPdfFromBytes = (fileName: string, base64String: string) => {
  try {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters?.length; i++) {
      byteNumbers[i] = byteCharacters?.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName.endsWith(".pdf") ? fileName : `${fileName}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  } catch (err) {
    console.error("Failed to download PDF", err);
  }
};

export const downloadDocFromBytes = (fileName: string, base64String: string) => {
  try {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName.endsWith(".docx") ? fileName : `${fileName}.docx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  } catch (err) {
    console.error("Failed to download DOCX", err);
  }
};

export const convertToUTCForFormReport = (date: Date | null | undefined): string | null => {
  if (!date) return null;
  const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
  return localDate.toISOString();
};

export const formatDateOnly = (date: Date | string | null | undefined): string | null => {
  if (!date) return null;

  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
    return null;
  }

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};